import { FilterRoomsInputs } from "../types";
import { Room, RoomStatus, RoomCategory, RoomPrivacy } from "../entities/room.entity";

// Filter query type matching the pattern used in lounge
export type RoomFilterQuery = Partial<{
  id: string;
  userId: string;
  status: RoomStatus;
  category: RoomCategory;
  privacy: RoomPrivacy;
  langCode: string;
  isScheduled: boolean;
}>;

export async function buildRoomsFilter(input: FilterRoomsInputs): Promise<RoomFilterQuery> {
  const filters: RoomFilterQuery = {};

  if (input.id) {
    filters.id = input.id;
  }

  if (input.userId) {
    filters.userId = input.userId;
  }

  if (input.status) {
    filters.status = input.status;
  }

  if (input.category) {
    filters.category = input.category;
  }

  if (input.privacy) {
    filters.privacy = input.privacy;
  }

  if (input.langCode) {
    filters.langCode = input.langCode;
  }

  if (input.isScheduled !== undefined) {
    filters.isScheduled = input.isScheduled;
  }

  return filters;
}
